/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgPolicyPlan } from '../models/LlgPolicyPlan';
import { ScheduleMode } from '../models/ScheduleMode';

export class LlgPolicy {
  /**
  * Backup policy ID.
  */
  'id': string;
  /**
  * LLG policy display name.
  */
  'name': string;
  /**
  * List of cloud-provider-assigned resource IDs to include in the LLG policy. 
  */
  'resourceInclusion': Array<string>;
  'policyPlan': LlgPolicyPlan;
  /**
  * The number of resources attached to the policy
  */
  'attachedResources'?: number;
  'scheduleMode'?: ScheduleMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceInclusion",
      "baseName": "resourceInclusion",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "policyPlan",
      "baseName": "policyPlan",
      "type": "LlgPolicyPlan",
      "format": ""
    },
    {
      "name": "attachedResources",
      "baseName": "attachedResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LlgPolicy.attributeTypeMap;
  }

  public constructor() {
  }
}



